import './PauseAdPlugin.css';
import { fireTrackingPixel} from "../../tracking-pixel";

class BitmovinPauseAdPlugin {

    /** PauseAd.js
     * Displays a banner ad when the video is paused.
     *
     * Based on the sample code provided by Tal from Google:
     * https://jsbin.com/yidulaleja/edit?html,js,output 
     * 
     * Virgin Code:
     * https://www.virginmediatelevision.ie/player/assets/video_js/videojs-pauseads-vodlimitedads.js?v=05100607
     */
    constructor(options) {
        console.log('Simplestream::PauseAd::Constructor()');

        // Validate options
        if(!options.parent) {
            console.error('Simplestream::PauseAd: Missing parent');
            return;
        } else if(!options.container) {
            console.error('Simplestream::PauseAd: Missing container');
            return;
        } else if(!options.vastTag) {
            console.error('Simplestream::PauseAd: Missing vastTag');
            return;
        }

        // Set options
        this.parent = options.parent;
        this.container = options.container;
        this.vastTag = options.vastTag;

        this.init();
    }

    /**
     * Initialise the pause ad container and events.
     */
    init() {
        console.log('Simplestream::PauseAd::init()');

        const htmlContent = `
        <div id="pauseAd" class="pausead-container">
            <div class="pausead-safearea">
                <div id="pauseAdSlot" class="pausead-slot"></div>
            </div>
            <div class="pausead-controls">
                <div id="pauseAdPlayButton" class="pausead-button">
                    Play
                </div>
            </div>
        </div>`;
        this.container.insertAdjacentHTML('beforeend', htmlContent);

        this.pauseAdContainer = document.getElementById('pauseAd');
        this.pauseAdPlayButton = document.getElementById('pauseAdPlayButton');
        this.pauseAdSlotContainer = document.getElementById('pauseAdSlotContainer');
        this.pauseAdSlot = document.getElementById('pauseAdSlot');

        this.pauseAdPlayButton.addEventListener('click', () => {
            console.log('Simplestream::PauseAd::Event Click');
            this.pauseAdContainerDisplay('hide');
            this.parent.player.play();
        });

        // Listen for the 'pause' event
        this.parent.player.on(bitmovin.player.PlayerEvent.Paused, () => {
            console.log('Simplestream::PauseAd::Event Pause');
            this.isPlayerPaused();
        });

        // Listen for the 'play' event
        this.parent.player.on(bitmovin.player.PlayerEvent.Play, () => {
            console.log('Simplestream::PauseAd::Event Play');
            this.pauseAdSlot.innerHTML = '';
            this.pauseAdContainerDisplay('hide');
        });

        // Track if the player is seeking
        this.isSeeking = false;
        this.parent.player.on(bitmovin.player.PlayerEvent.Seek, () => {
            this.isSeeking = true;
        });
        this.parent.player.on(bitmovin.player.PlayerEvent.Seeked, () => {
            this.isSeeking = false;
        });

    }

    /**
     * Determine if the player is paused.
     */
    isPlayerPaused() {
        console.log('Simplestream::PauseAd::isPlayerPaused()');
        var currentTime = this.parent.player.getCurrentTime();
        setTimeout(() => {
            var seekTime = this.parent.player.getCurrentTime();
            if(seekTime != currentTime) {
                console.log('Simplestream::PauseAd::isPlayerPaused() - Not a pause event, currentTime has changed.');
            } else {
                console.log('Simplestream::PauseAd::isPlayerPaused() - Pause event confirmed.');
                this.checkPauseAdsAreAllowed();
            }
        }, 3000);
    }

    /**
     * Determine if the player is in a state ready for pause ads.
     */
    checkPauseAdsAreAllowed() {
        
        console.log('Simplestream::PauseAd::checkPauseAdsAreAllowed()');

        if(this.isSeeking) {
            console.log('Video is seeking. Pause ad not allowed.');
            return
        }

        if(this.parent.player.getCurrentTime() <= 10) {
            //console.log('currentTime is less than 10 seconds. Pause ad not allowed.');
            //return;
        }

        this.checkDimensions();

    }

    /**
     * Check player is large enough to show the pause ad.
     */
    checkDimensions() {

        console.log('Simplestream::PauseAd::checkDimensions()');

        // Get the dimensions of the pause ad slot
        this.pauseAdSlotDimensions = this.pauseAdSlot.offsetWidth + 'x' + this.pauseAdSlot.offsetHeight;
        console.log('Pause Ad Slot: ' + this.pauseAdSlotDimensions);

        if(this.pauseAdSlotDimensions == '0x0') {
            console.log('Pause Ad Slot is too small. Pause ad not allowed.');
            return false;
        }

        this.loadAdsManager();

    }

    /**
     * Load the Google IMA SDK and request the pause ad.
     */
    loadAdsManager() {

        console.log('Simplestream::PauseAd::loadAdsManager()');

        // Modify the VAST tag
        const urlObj = new URL(this.vastTag);
        urlObj.searchParams.delete('sz');
        urlObj.searchParams.delete('correlator');
        const vastTag = urlObj.toString() + '&sz=' + this.pauseAdSlotDimensions + '&correlator=' + Date.now();

        console.log('VAST Tag: ' + vastTag);

        // Get the dimensions of the pause ad slot
        let [width, height] = this.pauseAdSlotDimensions.split('x');

        google.ima.settings.setPlayerType('bitmovin');
        google.ima.settings.setPlayerVersion('8.225.0');
        google.ima.settings.setLocale('en');
      
        // Create the ad display container.
        var adDisplayContainer = new google.ima.AdDisplayContainer(this.pauseAdSlot, this.videoElement);

        // Initialize the container. Must be done via a user action on mobile devices.
        adDisplayContainer.initialize();

        // Create ads loader.
        var adsLoader = new google.ima.AdsLoader(adDisplayContainer);

        // Listen and respond to ads loaded and error events.
        adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded.bind(this), false);
        adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this), false);

        // Request video ads.
        var adsRequest = new google.ima.AdsRequest();
        adsRequest.adTagUrl = vastTag;
        adsRequest.nonLinearAdSlotWidth = parseInt(width);
        adsRequest.nonLinearAdSlotHeight = parseInt(height);
        adsLoader.requestAds(adsRequest);

    }

    /**
     * After Google IMA SDK has loaded, show pause ad.
     */
    onAdsManagerLoaded(adsManagerLoadedEvent) {

        console.log('Simplestream::PauseAd::onAdsManagerLoaded()');

        var adsRenderingSettings = new google.ima.AdsRenderingSettings();
        adsRenderingSettings.autoAlign = false; // Aligns ad bottom center of pauseAdSlot
        adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
        
        this.adsManager = adsManagerLoadedEvent.getAdsManager(this.videoContent, adsRenderingSettings);
        this.adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.onContentPauseRequested.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.onContentResumeRequested.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, this.onAdEvent.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, this.onAdEvent.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, this.onAdEvent.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, this.onAdEvent.bind(this));

        // Add window resize listener
        window.addEventListener('resize', () => {

            // Get the dimensions of the pause ad slot
            this.pauseAdSlotDimensions = this.pauseAdSlot.offsetWidth + 'x' + this.pauseAdSlot.offsetHeight;
            console.log('Resized Pause Ad Slot: ' + this.pauseAdSlotDimensions);

            if(this.pauseAdSlotDimensions == '0x0') {
                console.log('Resized Pause Ad Slot is too small. Hide Pause Ad.');
                return false;
            }

            // Get the dimensions of the pause ad slot
            let [width, height] = this.pauseAdSlotDimensions.split('x');
            width = (parseInt(width) + 20);
            height = (parseInt(height) + 20);

            this.adsManager.resize(width, height, google.ima.ViewMode.NORMAL);

        });
        
        // Get the dimensions of the pause ad slot
        let [width, height] = this.pauseAdSlotDimensions.split('x');
        width = (parseInt(width) + 20);
        height = (parseInt(height) + 20);

        try {
            this.pauseAdContainerDisplay('show');
            this.adsManager.init(width, height, google.ima.ViewMode.NORMAL);
            this.adsManager.start();
        } catch (adError) {
            alert('error');
        }

        this.adsManager.resize(width, height, google.ima.ViewMode.NORMAL);

    }

    /**
     * Hide/Show the pause ad container by adjusting the z-index.
     */
    pauseAdContainerDisplay(state) {
        console.log('Simplestream::PauseAd::pauseAdContainerDisplay(\'' + state + '\')');
        if(state == 'show') {
            this.pauseAdContainer.style.zIndex = 10000;
        } else {
            this.pauseAdContainer.style.zIndex = -1;
        }
    }
    
    /**
     * Handle ad events.
     */
    async onAdEvent(adEvent) {

        console.log('Simplestream::PauseAd::onAdEvent() - ' + adEvent.type);

        switch (adEvent.type) {
            case google.ima.AdEvent.Type.LOADED:
                break;
            case google.ima.AdEvent.Type.STARTED:
                this.pauseAdContainerDisplay('show');
                console.log('Pause Ad', adEvent.getAd());
                break;
            case google.ima.AdEvent.Type.COMPLETE:
                break;
        }

        let impressionUrls = [];
        let clickthroughTrackingUrls = [];

        try {
            const result = await this.getVastDetails(this.vastTag);
            impressionUrls = Array.isArray(result?.impressionUrls) ? result.impressionUrls : [];
            clickthroughTrackingUrls = Array.isArray(result?.clickthroughTrackingUrls) ? result.clickthroughTrackingUrls : [];
        } catch (error) {
            console.error('...Error getting VAST details:', error);
            return;
        }

        if (impressionUrls && impressionUrls.length > 0) {
            await this.fireTrackers(impressionUrls);
            console.log('...impression fired');
        }

        if(clickthroughTrackingUrls.length > 0) {
            await this.fireTrackers(clickthroughTrackingUrls);
            console.log('...click tracker fired');
        }

    }
    
    /**
     * Handle ad error.
     */
    onAdError(adErrorEvent) {
        console.log('Simplestream::PauseAd::onAdError()');
        var error = adErrorEvent.getError();
        console.error('Code: ' + error.data.errorCode + ' / Message: ' + error.data.errorMessage);
        //this.adsManager.destroy();
        //this.pauseAdContainerDisplay('hide');
    }
    
    /**
     * Is this needed?
     */
    onContentPauseRequested() {
        console.log('Simplestream::PauseAd::onContentPauseRequested()');
        this.videoContent.pause();
    }
    
    /**
     * Is this needed?
     */
    onContentResumeRequested() {
        console.log('Simplestream::PauseAd::onContentResumeRequested()');
        this.videoContent.play();
    }

    async getVastDetails(vastUrl) {
        console.log('...Fetching VAST details from:', vastUrl);
        const resp = await fetch(vastUrl);
        if (!resp.ok) {
            throw new Error(`HTTP ${resp.status} loading VAST`);
        }

        let xml = await resp.text();
        
        // Strip BOM if present
        xml = xml.replace(/^\uFEFF/, "");
        const dom = new DOMParser().parseFromString(xml, "application/xml");

        if (dom.getElementsByTagName("parsererror").length > 0) {
            console.error("...VAST XML parse error:", dom);
            throw new Error("...Invalid VAST XML");
        }

        // Get Impression URLs
        const impressionUrls = Array.from(dom.getElementsByTagName("Impression"))
            .map(node => node.textContent?.trim())
            .filter(url => url);

        // Get clickthrough tracking URLs (from <NonLinearTracking> or correct tag)
        const clickthroughTrackingUrls = Array.from(dom.getElementsByTagName("NonLinearClickTracking"))
            .map(node => node.textContent?.trim())
            .filter(url => url);

        console.log('...Found VAST URLs:', impressionUrls, clickthroughTrackingUrls);

        return { impressionUrls, clickthroughTrackingUrls };
    }

    async fireTrackers(urls){
        if (!urls || !Array.isArray(urls)) return;

        await Promise.allSettled(
            urls.map(url => {
                if (url) {
                    return fireTrackingPixel(url)
                        .catch(error => console.error('...Error firing tracking pixel:', error, url));
                }
                return Promise.resolve();
            })
        );
    }

}

export default BitmovinPauseAdPlugin;